// Город вылета по умолчанию в случае ошибки геолокации
export const DEFAULT_GEO_CITY = {
    cityFromId: 832,
    departureCityId: 832,
    id: 1055,
    name: 'Москва',
    populationKind: 1,
    regionName: 'Москва',
    countryId: 150
};

export const DEFAULT_DEPART_CITY = {
    id: 832,
    name: 'Москва',
    countryId: 150
};
